import { SET_CREDIT_APP } from './types';
import { createSelector } from 'reselect';

const initialState = {};

export const creditAppReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CREDIT_APP:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const contacts = state =>
  [
    state.creditApp?.primaryContact,
    ...(state.creditApp?.creditApplicationOwner ?? []),
    ...(state.creditApp?.creditApplicationContacts ?? []),
  ]
    .filter(Boolean)
    .map(owner => ({
      ...owner,
      phone: owner?.phone || owner?.mobilePhone || owner?.homePhone || owner?.workPhone,
      fullName: `${owner.firstName} ${owner.lastName}`,
    }));

const contact = (state, ownerId) => state.creditApp.creditApplicationOwner?.find(owner => owner.ownerPgId === ownerId);

const customerData = state => {
  if (state.creditApp?.primaryContact) {
    return state.creditApp.primaryContact;
  }

  return state.creditApp?.creditApplicationOwner?.find(o => o.pc) ?? state.creditApp?.creditApplicationOwner?.[0];
};

const customerPrioritizePhone = createSelector([customerData], customerData => {
  return (customerData?.phone || customerData?.mobilePhone || customerData?.homePhone || customerData?.workPhone) ?? '';
});

const contactSelectOptions = state => {
  const allContacts = [
    state?.creditApp?.primaryContact,
    ...(state?.creditApp?.creditApplicationOwner ?? []),
    ...(state?.creditApp?.creditApplicationContacts ?? []),
  ];

  return allContacts.reduce((options, owner) => {
    if (!owner || options.map(option => option.value).includes(owner.ownerPgId)) return options;

    options.push({
      label: owner.title
        ? `${owner.firstName} ${owner.lastName}, ${owner.title}`
        : `${owner.firstName} ${owner.lastName}`,
      value: owner.ownerPgId,
    });

    return options;
  }, []);
};

const creditAppSelectors = {
  contact,
  contacts,
  customerData,
  contactSelectOptions,
  customerPrioritizePhone,
};

export { creditAppSelectors };
